export default __webpack_public_path__ + "static/zahid_head-c734398929fe59fabacc5091e8a5972f.png";